<template>
  <div class="about-page">
    <div class="about-header">
      <div class="about-icon">
        <svg viewBox="0 0 80 80" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="aboutMoonGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
            </linearGradient>
            <linearGradient id="aboutGlowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#3b82f6;stop-opacity:0.2" />
              <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:0.05" />
            </linearGradient>
          </defs>
          <circle cx="40" cy="40" r="38" fill="url(#aboutGlowGradient)" />
          <path d="M40 8 C24 8 12 24 12 40 C12 56 24 72 40 72 C28 64 28 16 40 8" fill="url(#aboutMoonGradient)" />
          <path d="M56 36 L64 24 L72 36" stroke="#3b82f6" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M64 28 L64 52" stroke="#3b82f6" stroke-width="4" fill="none" stroke-linecap="round" />
          <circle cx="52" cy="16" r="3" fill="#fbbf24" />
          <circle cx="68" cy="56" r="2" fill="#3b82f6" />
        </svg>
      </div>
      <h1>{{ $t('about.title') }}</h1>
      <p>{{ $t('about.subtitle') }}</p>
    </div>

    <div class="about-content">
      <section>
        <h2>🚀 {{ $t('about.mission') }}</h2>
        <p>{{ $t('about.missionDesc') }}</p>
      </section>

      <section>
        <h2>✨ {{ $t('about.features') }}</h2>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon">🆓</div>
            <h3>{{ $t('about.featureFree') }}</h3>
            <p>{{ $t('about.featureFreeDesc') }}</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🔒</div>
            <h3>{{ $t('about.featureSecure') }}</h3>
            <p>{{ $t('about.featureSecureDesc') }}</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">⚡</div>
            <h3>{{ $t('about.featureFast') }}</h3>
            <p>{{ $t('about.featureFastDesc') }}</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">📱</div>
            <h3>{{ $t('about.featureCross') }}</h3>
            <p>{{ $t('about.featureCrossDesc') }}</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🌙</div>
            <h3>{{ $t('about.featureDark') }}</h3>
            <p>{{ $t('about.featureDarkDesc') }}</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🔄</div>
            <h3>{{ $t('about.featureUpdate') }}</h3>
            <p>{{ $t('about.featureUpdateDesc') }}</p>
          </div>
        </div>
      </section>

      <section>
        <h2>📬 {{ $t('about.contact') }}</h2>
        <p>{{ $t('about.contactDesc') }}</p>
        <ul>
          <li>{{ $t('about.website') }}：<a href="https://ysgjw.com">ysgjw.com</a></li>
          <li>{{ $t('about.email') }}：hitszwangyuesheng@gmail.com</li>
        </ul>
        <p>{{ $t('about.contactPromise') }}</p>
      </section>

      <section>
        <h2>📖 {{ $t('about.story') }}</h2>
        <p>{{ $t('about.storyDesc') }}</p>
        <p>{{ $t('about.storyDesc2') }}</p>
      </section>

      <section>
        <h2>📅 {{ $t('about.milestones') }}</h2>
        <ul class="milestones-list">
          <li v-for="(item, index) in $t('about.milestonesItems')" :key="'ms'+index">{{ item }}</li>
        </ul>
      </section>

      <section>
        <h2>🔐 {{ $t('about.privacyCommitment') }}</h2>
        <p>{{ $t('about.privacyDesc') }}</p>
        <p>{{ $t('about.privacyLink') }}<router-link to="/privacy">{{ $t('about.privacyPage') }}</router-link>。</p>
      </section>

      <section>
        <h2>🛠️ {{ $t('about.techStack') }}</h2>
        <p>{{ $t('about.techStackDesc') }}</p>
        <ul>
          <li v-for="(item, index) in $t('about.techStackItems')" :key="'tech'+index">{{ item }}</li>
        </ul>
      </section>

      <section>
        <h2>💡 {{ $t('about.faq') }}</h2>
        <div class="faq-list">
          <div class="faq-item">
            <h3>{{ $t('about.faqFree') }}</h3>
            <p>{{ $t('about.faqFreeAnswer') }}</p>
          </div>
          <div class="faq-item">
            <h3>{{ $t('about.faqRegister') }}</h3>
            <p>{{ $t('about.faqRegisterAnswer') }}</p>
          </div>
          <div class="faq-item">
            <h3>{{ $t('about.faqSuggestion') }}</h3>
            <p>{{ $t('about.faqSuggestionAnswer') }}</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about-page {
  max-width: 900px;
  margin: 0 auto;
}

.about-header {
  text-align: center;
  margin-bottom: 40px;
}

.about-icon {
  margin-bottom: 20px;
}

.about-icon svg {
  filter: drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3));
}

.about-header h1 {
  font-size: 36px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, var(--accent-color), #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.about-header p {
  color: var(--text-secondary);
  font-size: 18px;
}

.about-content {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 40px;
  box-shadow: var(--shadow-md);
}

section {
  margin-bottom: 40px;
}

section:last-child {
  margin-bottom: 0;
}

h2 {
  font-size: 22px;
  color: var(--text-primary);
  margin-bottom: 20px;
}

h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 12px;
}

ul {
  padding-left: 24px;
  margin-bottom: 12px;
}

li {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 4px;
}

a {
  color: var(--accent-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.feature-item {
  background: var(--bg-tertiary);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s;
}

.feature-item:hover {
  transform: translateY(-4px);
}

.feature-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.feature-item h3 {
  margin-bottom: 8px;
}

.feature-item p {
  font-size: 13px;
  margin-bottom: 0;
}

.tools-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.tool-category {
  background: var(--bg-tertiary);
  border-radius: 12px;
  padding: 20px;
}

.tool-category h3 {
  color: var(--accent-color);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
}

.tool-category ul {
  padding-left: 20px;
  margin-bottom: 0;
}

.tool-category li {
  font-size: 14px;
}

.faq-list {
  display: grid;
  gap: 16px;
}

.faq-item {
  background: var(--bg-tertiary);
  border-radius: 12px;
  padding: 20px;
}

.faq-item h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.faq-item p {
  font-size: 14px;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .about-content {
    padding: 24px;
  }

  .about-header h1 {
    font-size: 28px;
  }

  h2 {
    font-size: 18px;
  }

  .features-grid,
  .tools-list {
    grid-template-columns: 1fr;
  }
}
</style>
